<div *ngIf="file?.url" class="section-block object-block" [ngClass]="openCommentPanel ? 'comment-panel-open' : ''" rlAnnotatorContainer [config]="annotatorConfig">
  <rl-please-wait class="document-loader" [hidden]="!busy" [disable]="false"></rl-please-wait>
  <rl-toolbar [hidden]="busy" [page]="config.page" [config]="toolbarConfig" [entityType]="file.entityType" (onSelectTool)="applyTool($event)" class="toolbar-holder"></rl-toolbar>
  <rl-pdf-viewer
    rlAnnotatorFile
    class="embedded-content-holder"
    [ngClass]="{ 'side-pane-open': openCommentPanel, 'hide-annotations': hideFileAnnotations }"
    [url]="file.url"
    [config]="config"
    (afterInit)="afterFileLoaded($event)"
    (afterLoad)="reloadAnnotations($event)"
    (searchResultsUpdated)="searchResultsUpdated($event)"></rl-pdf-viewer>
  <!-- <div *ngIf="tabScanner" class="scanner" disable="false">
      <span class="scan"></span>
    </div> -->
  <div class="open-panel-holder" *ngIf="file.entityType !== 'COLLECTION' && !isGuest">
    <button

      rlAnnotatorCommentBtn
      class="btn"
      [ngClass]="openCommentPanel ? ' btn-icon-only side-edit-mode-btn-close' : 'btn-link'"
      id="open-comments-panel"
      (click)="commentPanel()"
      type="button"
      data-tooltype="point"
      attr.uib-tooltip="Comment"
      tooltip-trigger="'focus mouseenter'"
      tooltip-placement="auto"
      [attr.aria-label]="(openCommentPanel ? 'comments_panel.close' : 'comments_panel.open') | translate">
      <span *ngIf="!openCommentPanel">
        <i class="fa fa-commenting no-margin" attr.aria-hidden="true"></i>
        <span class="badge" *ngIf="getTotalComment() > 0">{{ getTotalComment() | limit }}</span>
      </span>
      <span *ngIf="openCommentPanel">
        <span class="sr-only">{{ 'comments_panel.close' | translate }}</span>
        <span>&#x2715;</span>
      </span>
    </button>
  </div>
  <rl-annotator-comments-panel
    *ngIf="file.entityType !== 'COLLECTION'"
    [hidden]="!openCommentPanel || busy"
    [allowRefresh]="annotatorConfig.allowRefresh"
    [config]="annotatorConfig"
    class="comments-holder"
    (onClose)="commentPanel()"></rl-annotator-comments-panel>
</div>
